<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="气候">
                <a-select v-model="queryParam.climateId" allowClear>
                  <a-select-option v-for="item in climateList" :value="item.id" :key="item.id">{{ item.climateName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="土地类型">
                <a-select v-model="queryParam.landType" allowClear>
                  <a-select-option v-for="(item, index) in customDict.LandTypeEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="土地状态">
                <a-select v-model="queryParam.status" allowClear>
                  <a-select-option v-for="(item, index) in customDict.LandStatusEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="监控支付状态">
                <a-select v-model="queryParam.monitorPayStatus" allowClear>
                  <a-select-option v-for="(item, index) in customDict.MonitorPayStatusEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="土地位置">
                <a-input v-model="queryParam.position" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userMobile" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户昵称">
                <a-input v-model="queryParam.userNickName" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['cloudplant:land:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['cloudplant:land:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns" :refresh-loading="loading" @refresh="getList" />
      </div>

      <create-form ref="createForm" @ok="getList" />

      <!-- 数据表格 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false" :bordered="tableBordered">
        <span slot="landType" slot-scope="text, record">
          <a-tag v-if="record.landType === 1" color="blue">大厅土地</a-tag>
          <a-tag v-else-if="record.landType === 2" color="green">用户土地</a-tag>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="orange">未种植</a-tag>
          <a-tag v-else-if="record.status === 2" color="green">已种植</a-tag>
        </span>
        <span slot="monitorPayStatus" slot-scope="text, record">
          <a-tag v-if="record.monitorPayStatus === 0">未支付</a-tag>
          <a-tag v-else-if="record.monitorPayStatus === 1" color="orange">待分配</a-tag>
          <a-tag v-else-if="record.monitorPayStatus === 2" color="green">已分配</a-tag>
        </span>
        <span slot="expireTime" slot-scope="text, record">
          {{ record.durationMonths === 0 || !record.durationMonths ? '永久' : parseTime(record.expireTime) }}
        </span>
        <span slot="monitorExpireTime" slot-scope="text, record">
          {{ record.monitorPayStatus === 2 ? (record.monitorDurationMonths === 0 || !record.monitorDurationMonths ? '永久' : parseTime(record.monitorExpireTime)) : '' }}
        </span>
        <span slot="createTime" slot-scope="text, record">{{ parseTime(record.createTime) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a v-if="record.monitorPayStatus === 1 || record.monitorPayStatus === 2" @click="handleAssignMonitor(record)" v-hasPermi="['cloudplant:land:edit']"><a-icon type="camera" />分配监控</a>
          <a-divider type="vertical" v-if="record.monitorPayStatus === 1" />
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['cloudplant:land:edit']"><a-icon type="edit" />修改</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['cloudplant:land:remove']"><a-icon type="delete" />删除</a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`" @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>

    <!-- 分配监控弹窗 -->
    <a-modal
      title="分配监控"
      :visible="assignMonitorVisible"
      :confirm-loading="assignLoading"
      @ok="handleAssignConfirm"
      @cancel="assignMonitorVisible = false"
      width="600px"
    >
      <a-form-model label-width="100px">
        <a-form-model-item label="选择监控">
          <a-select v-model="selectedMonitorId" placeholder="请选择监控">
            <a-select-option v-for="item in monitorList" :value="item.id" :key="item.id">
              {{ item.deviceName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageLand, delLand, assignMonitor } from '@/api/cloudplant/land'
import { listClimate } from '@/api/cloudplant/climate'
import { listMonitor } from '@/api/cloudplant/monitor'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import CreateForm from './modules/CreateForm'

export default {
  name: 'LandLand',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [], climateList: [], pageSizeOptions: ['10', '20', '50', '100'], selectedRowKeys: [], multiple: true, loading: false, total: 0,
      queryParam: { climateId: undefined, landType: undefined, status: undefined, monitorPayStatus: undefined, position: undefined, userMobile: undefined, userNickName: undefined, pageNum: 1, pageSize: 10 },
      assignMonitorVisible: false,
      assignLoading: false,
      currentLandId: null,
      monitorList: [],
      selectedMonitorId: undefined,
      columns: [
        { title: '气候', dataIndex: 'climateName', align: 'center' },
        { title: '土地类型', dataIndex: 'landType', scopedSlots: { customRender: 'landType' }, align: 'center', width: 100 },
        { title: '用户昵称', dataIndex: 'userNickName', align: 'center' },
        { title: '面积(㎡)', dataIndex: 'area', align: 'center', width: 80 },
        { title: '位置', dataIndex: 'position', align: 'center' },
        { title: '种植种子', dataIndex: 'seedName', align: 'center' },
        { title: '土地时效(月)', dataIndex: 'durationMonths', align: 'center', width: 100 },
        { title: '土地状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: '土地到期时间', scopedSlots: { customRender: 'expireTime' }, align: 'center', width: 160 },
        { title: '监控设备', dataIndex: 'monitorDeviceName', align: 'center' },
        { title: '监控状态', dataIndex: 'monitorPayStatus', scopedSlots: { customRender: 'monitorPayStatus' }, align: 'center', width: 100 },
        { title: '监控到期时间', scopedSlots: { customRender: 'monitorExpireTime' }, align: 'center', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  computed: { ...mapGetters(['customDict']) },
  created() { this.getList(); this.getClimateList() },
  methods: {
    getList() {
      this.loading = true
      pageLand(this.queryParam).then(response => { this.list = response.data.records; this.total = response.data.total; this.loading = false })
    },
    getClimateList() { listClimate({}).then(response => { this.climateList = response.data }) },
    handleQuery() { this.queryParam.pageNum = 1; this.getList() },
    resetQuery() { this.queryParam = { climateId: undefined, landType: undefined, status: undefined, monitorPayStatus: undefined, position: undefined, userMobile: undefined, userNickName: undefined, pageNum: 1, pageSize: 10 }; this.handleQuery() },
    onShowSizeChange(current, pageSize) { this.queryParam.pageSize = pageSize; this.getList() },
    changeSize(current, pageSize) { this.queryParam.pageNum = current; this.queryParam.pageSize = pageSize; this.getList() },
    onSelectChange(selectedRowKeys) { this.selectedRowKeys = selectedRowKeys; this.multiple = !selectedRowKeys.length },
    handleDelete(row) {
      const that = this
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: '确认删除所选中数据?',
        onOk() {
          let data = []
          if (row.id) { data.push({ id: row.id }) } else { that.selectedRowKeys.forEach(id => data.push({ id: id })) }
          return delLand(data).then(() => { that.onSelectChange([]); that.getList(); that.$message.success('删除成功', 3) })
        }
      })
    },
    handleAssignMonitor(row) {
      this.currentLandId = row.id
      this.selectedMonitorId = undefined
      this.getMonitorList()
      this.assignMonitorVisible = true
    },
    getMonitorList() {
      listMonitor({}).then(response => {
        this.monitorList = response.data
      })
    },
    handleAssignConfirm() {
      if (!this.selectedMonitorId) {
        this.$message.warning('请选择监控')
        return
      }
      this.assignLoading = true
      assignMonitor({ landId: this.currentLandId, monitorId: this.selectedMonitorId }).then(() => {
        this.$message.success('分配成功')
        this.assignMonitorVisible = false
        this.getList()
      }).finally(() => {
        this.assignLoading = false
      })
    }
  }
}
</script>
